import { useEffect, useState } from "react";
import { Play, Star } from "lucide-react";

const ROUND = 30;
const spot = () => ({ x: 8 + Math.random() * 76, y: 8 + Math.random() * 76, id: Math.random() });

export const StarCatch = ({ onFinish }) => {
  const [on, setOn] = useState(false);
  const [left, setLeft] = useState(ROUND);
  const [score, setScore] = useState(0);
  const [star, setStar] = useState(spot);

  useEffect(() => {
    if (!on) return;
    if (left <= 0) { setOn(false); onFinish(score, score >= 22 ? 3 : score >= 15 ? 2 : score >= 8 ? 1 : 0); return; }
    const t = setTimeout(() => setLeft((l) => l - 1), 1000);
    return () => clearTimeout(t);
  }, [on, left, score, onFinish]);

  useEffect(() => {
    if (!on) return;
    const speed = Math.max(550, 1100 - score * 25);
    const t = setTimeout(() => setStar(spot()), speed);
    return () => clearTimeout(t);
  }, [on, star, score]);

  const catchIt = () => { setScore((s) => s + 1); setStar(spot()); };

  if (!on && left === ROUND) {
    return (
      <div className="zn-card bg-[#9BD0FF] p-8 text-center max-w-md mx-auto">
        <p className="font-display text-2xl font-bold mb-2">Tap the zooming star as many times as you can in {ROUND} seconds!</p>
        <button data-testid="stars-start-btn" onClick={() => setOn(true)} className="zn-btn bg-[#FF6B4A] text-white mt-4"><Play size={18} /> Start</button>
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto">
      <div className="flex justify-between font-display text-lg mb-3"><span data-testid="stars-score">Caught: {score}</span><span data-testid="stars-timer">{left}s</span></div>
      <div data-testid="stars-arena" className="relative w-full aspect-[4/5] sm:aspect-[16/10] rounded-3xl border-[3px] border-[#1B1A2E] bg-[#1B1A2E] overflow-hidden zn-dots touch-none select-none">
        {on && (
          <button key={star.id} data-testid="stars-target" onPointerDown={catchIt} aria-label="Catch the star"
            className="absolute w-16 h-16 -ml-8 -mt-8 grid place-items-center rounded-full zn-pop" style={{ left: `${star.x}%`, top: `${star.y}%` }}>
            <Star size={52} fill="#FFD23F" color="#1B1A2E" strokeWidth={2} />
          </button>
        )}
      </div>
    </div>
  );
};
